var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sfcDeleteNode",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 1024 1024",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M106.666667 213.333333h810.666666v42.666667H106.666667z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M640 128v42.666667h42.666667V128c0-23.573333-19.093333-42.666667-42.538667-42.666667H383.872A42.496 42.496 0 0 0 341.333333 128v42.666667h42.666667V128h256z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M213.333333 896V256H170.666667v639.957333C170.666667 919.552 189.653333 938.666667 213.376 938.666667h597.248C834.218667 938.666667 853.333333 919.68 853.333333 895.957333V256h-42.666666v640H213.333333z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M320 341.333333h42.666667v384h-42.666667zM490.666667 341.333333h42.666666v384h-42.666666zM661.333333 341.333333h42.666667v384h-42.666667z",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }